import React from 'react';

import MaskedInput from './MaskedInput';

const DateInput = (props) => (
  <MaskedInput mask="11/11/1111" placeholder="  /  /    " placeholderChar=" " {...props} />
);

export default DateInput;
